import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { ApiService } from "src/app/shared/services/api.service";

@Component({
  selector: "app-purchase-plan",
  standalone: false,
  templateUrl: "./purchase-plan.component.html",
  styleUrl: "./purchase-plan.component.css",
})
export class PurchasePlanComponent implements OnInit {
  monthOptions: number[] = Array.from({ length: 24 }, (_, i = 2) => i + 1);

  selectedDomains: string[] = [];
  domains = [
    { name: 'Consultancy', price: 1000, unit: 'per project', description: 'Expert-based analysis' },
    { name: 'Road', price: 1.5, unit: 'per km', description: 'Road infrastructure planning' },
    { name: 'Construction', price: 1.5, unit: 'per sq.m.', description: 'Construction project management' },
    { name: 'Utilities', price: 4.5, unit: 'per sq.m.', description: 'Water & electricity infrastructure' },
  ];

  form: FormGroup;
  totalAmount = 0;

  headerLogo: string | undefined = "../../assets/image/logo.png";
  supportContactEmail: string | undefined = "support@sigmat.in";
  supportContactNumber: string | undefined = "+91 4442624172";

  constructor(
    private fb: FormBuilder, 
    private apiService: ApiService, 
    private router: Router
  ) {
    const userData = JSON.parse(localStorage.getItem("user") || '{}');
    this.selectedDomains = userData.user?.domain?.split(",") || [];
    
    this.form = this.fb.group({
      organization_id: [userData.user?.branch_id || userData.user?.org_id],
      duration: [3],
      total_amount: 0,
      users_count: [0],
      consultancy_projects: [0],
      Road: this.fb.group({
        users_count: [0]
      }),
      Construction: this.fb.group({
        users_count: [0],
      }),
      Utilities: this.fb.group({
        users_count: [0],
      }),
      Consultancy: this.fb.group({
        users_count: [0],
        projects: [0]
      })
    });
  }

  ngOnInit(): void {
    this.calculateTotal();
  }

  onDomainChange(event: any): void {
    const domainName = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      this.selectedDomains.push(domainName);
    } else {
      this.selectedDomains = this.selectedDomains.filter(d => d !== domainName);
    }
    
    this.calculateTotal();
  }

  calculateTotal(): void {
    let total = 0;
    
    this.selectedDomains.forEach(domainName => {
      const domain = this.domains.find(d => d.name === domainName);
      if (domain) {
        const domainForm = this.form.get(domainName) as FormGroup;
        if (domainForm) {
          const usersCount = domainForm.get('users_count')?.value || 0;
          const projects = domainForm.get('projects')?.value || 0;
          
          if (domainName === 'Consultancy') {
            total += domain.price * projects;
          } else {
            total += domain.price * usersCount;
          }
        }
      }
    });

    const duration = this.form.get('duration')?.value || 1;
    this.totalAmount = total * duration;
    this.form.patchValue({ total_amount: this.totalAmount });
  }

  proceedToPayment(): void {
    if (this.totalAmount <= 0) {
      alert('Please select at least one domain and configure it properly.');
      return;
    }

    const formData = {
      ...this.form.value,
      selected_domains: this.selectedDomains,
      total_amount: this.totalAmount
    };

    console.log('Purchase Plan Data:', formData);
    
    // Here you would typically navigate to payment or save the plan
    alert(`Purchase plan configured for ₹${this.totalAmount}. Proceeding to payment...`);
    
    // Navigate to payment or next step
    // this.router.navigate(['/payment']);
  }

  goBack(): void {
    this.router.navigate(['/home/dashboard']);
  }

  getDomainPrice(domainName: string): number {
    const domain = this.domains.find(d => d.name === domainName);
    return domain ? domain.price : 0;
  }

  getDomainUnit(domainName: string): string {
    const domain = this.domains.find(d => d.name === domainName);
    return domain ? domain.unit : '';
  }
}
